<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItemSelected" >Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-half">
          <h2 class="title is-2">Contáctenos</h2>
          <br/>
          <h4>Llámenos al (502) 2478 - 1179 o envíenos sus preguntas o comentarios vía email. Intentaremos responder todas sus preguntas en los siguientes 2 a 3 días hábiles</h4>
          <br/>

          <form @submit.prevent="validateBeforeSubmit">
            <div class="field">
              <label class="label labelClass">Nombre</label>
              <p class="control">
                <input v-model="contact_name" v-validate="'required'" data-vv-as="nombre" :class="{'input': true, 'is-danger': errors.has('contact_name') }" type="text" name="contact_name" />
                <span v-show="errors.has('contact_name')" class="help is-danger">{{ errors.first('contact_name') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Empresa</label>
              <p class="control">
                <input v-model="contact_company" v-validate="'required'" data-vv-as="company" :class="{'input': true, 'is-danger': errors.has('contact_company') }" type="text" name="contact_company" />
                <span v-show="errors.has('contact_company')" class="help is-danger">{{ errors.first('contact_company') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Correo Electrónico</label>
              <p class="control">
                <input v-model="contact_email" v-validate="'required|email'" data-vv-as="correo electrónico" :class="{'input': true, 'is-danger': errors.has('contact_email') }" name="contact_email" type="email" />
                <span v-show="errors.has('contact_email')" class="help is-danger">{{ errors.first('contact_email') }}</span>
              </p>
            </div>

            <div class="field">
              <label class="label labelClass">Mensaje</label>
              <p class="control">
                <textarea v-model="contact_message" v-validate="'required'" data-vv-as="mensaje" :class="{'textarea': true, 'is-danger': errors.has('contact_message') }" name="contact_message"/>
                <span v-show="errors.has('contact_message')" class="help is-danger">{{ errors.first('contact_message') }}</span>
              </p>
            </div>

            <div class="field is-grouped">
              <div class="control">
                <button class="button is-primary" v-on:click="send()">Enviar</button>
              </div>
            </div>
          </form>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="logoClass" src="/static/logo.png">
            <p class="footerInfo">
              Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
              tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
              asesoría técnica profesional, capacitación y productos efectivos a precios justos.
            </p>
          </div>
          <div class="column is-4">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z" >
              <img width="400px" height="300px" class="mapInfo" src="/static/images/newmap.png"/>
            </a>
          </div>
          <div class="column">
            <p class="footerContact">
              2da calle 18-87 sector B-1<br/>
              Ciudad San Cristóbal zona 8 de Mixco<br/>
              Guatemala<br/>
              (502) 2478-1179 / 80 / 82 / 99<br/><br/>
              <a href="https://wa.me/50240251346">
                <img width="20px" height="20px" src="/static/images/whatsapp-icon.png" class="iconImage">
                WhatsApp: (502) 4025 - 1346
              </a><br/><br/>
              <a href="mailto:ventas@hipromeasa.com">
                <img width="20px" height="20px" src="/static/images/mail-icon.png" class="iconImage">
                E-Mail: ventas@hipromeasa.com
              </a><br/><br/>
              <a href="https://www.facebook.com/hipromeasa">
                <img width="20px" height="20px" src="/static/images/facebook-icon.png" class="iconImage">
                Estamos en Facebook
              </a>
            </p>
          </div>
        </div>
        <div class="content has-text-centered">
          <p class="footerLast">2025 - Todos los derechos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import spanish from 'vee-validate/dist/locale/es'
import ApiClient from '@/api/ApiClient.js'

export default {
  name: 'landing',
  data () {
    return {
      contact_name: '',
      contact_email: '',
      contact_message: '',
      contact_company: '',
      isLogged: localStorage.getItem('email') !== null
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    validateBeforeSubmit: function () {
      this.$validator.validateAll().then((result) => {
        return result
      })
    },
    send: function () {
      ApiClient.contact(this.contact_name, this.contact_email, this.contact_company, this.contact_message).then(response => {
        if (response.data.success) {
          alert('Información enviada exitosamente, estaremos en contacto con usted muy pronto.')
          this.$router.push('/')
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    }
  },
  created: function () {
    this.$validator.localize('es', {
      messages: spanish.messages
    })
    this.$validator.localize('es')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 60px;
    width: 220px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .labelClass {
    text-align: left;
  }
  .footerInfo {
    margin-left: 60px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:80px;
    margin-top: 30px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
    margin-top: -10px;
  }
  .mapInfo {
    padding-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .iconImage {
    vertical-align: middle;
    padding-bottom: 2px;
  }
  .is-primary {
    background-color: #BBDDE6 !important;
    color: #000000 !important;
  }
  .is-primary:hover {
    color: #BBDDE6 !important;
    background-color: #000000 !important;
  }

</style>



// WEBPACK FOOTER //
// ContactComponent.vue?9c2a8514